$(document).ready(function () {
    const descriptionDiv = $('#fabric-description');
    const defaultDescription = descriptionDiv.html();
    const dataUrl = window.fabricDescriptionsUrl || '/assets/fabric-descriptions.json';
    let fabricDescriptions = null;

    function normalizeFabricName(str) {
        return str.toLowerCase()
            .replace(/[’'\.]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .trim();
    }

    function loadDescriptions() {
        return fetch(dataUrl)
            .then((response) => response.ok ? response.json() : Promise.reject(response))
            .then((json) => {
                fabricDescriptions = json;
            })
            .catch(() => {
                fabricDescriptions = {};
            });
    }

    function updateFabricDescription() {
        const selectedFabric = $('#itemType option:selected').text().trim();
        const key = normalizeFabricName(selectedFabric);
        const html = fabricDescriptions && fabricDescriptions[key];

        if (html && html.trim()) {
            $('.description-margin').html(html);
        } else {
            $('.description-margin').html(defaultDescription);
        }
    }

    loadDescriptions().then(() => {
        $('#itemType').on('change select2:select', updateFabricDescription);
        $('#itemType').on('change', updateFabricDescription);
        updateFabricDescription();
    });
});